import { mutationTypes, actionTypes } from 'BASE/store/types'
import CONSTANT from 'BASE/common/chat/chat.constant'
import SETTING from 'BASE/common/chat/chat.setting'
import GroupRoomMemberRequestBuilder from 'BASE/common/chat/chat.groupRoomMemberRequestBuilder'

export default {
    props: {
        dialog: Object,
    },
    data: function () {
        return {
            roomSelected: "",
            errorMessage: "",
        }
    },
    methods: {
        confirm: async function () {
            let room = this.$store.state.chat.rooms.find((item) => item.id === this.roomSelected);
            if (!room) {
                this.errorMessage = "请选择聊天室";
                return;
            }

            let builder = new GroupRoomMemberRequestBuilder();
            builder.addRoom(room.id);
            builder.addMemberToRoom(room.id, this.dialog.data.loginId);

            let loader;
            if (SETTING.ENABLE_CHECK_CONNECTION_BEFORE_ACTION) {
                loader = this.$loading.show();
            }

            this.errorMessage = await this.$store.dispatch(actionTypes.CHAT_ADD_GROUP_ROOM_MEMBER, {
                builder: builder,
                connectionParams: {
                    waitConnected: true,
                },
            });

            if (SETTING.ENABLE_CHECK_CONNECTION_BEFORE_ACTION) {
                loader.hide();
            }
            
            if (!this.errorMessage) {
                this.cancel();
            }
        },
        cancel: function () {
            this.roomSelected = "";
            this.errorMessage = "";
            this.dialog.$emit('close');
        },
    },
    computed: {
        rooms: function () {
            return this.$store.state.chat.rooms.filter((item) => item.type === CONSTANT.roomType.DESCENDANT_GROUP);
        },
    }
};